<template>
  <div>
    <h1>Manage Payroll Assignments</h1>

    <b-modal id="modal-crud" hide-header hide-footer>
      <h2>Edit Payroll Specialist Assignment</h2>
      <hr/>
      <form ref="form" @submit.prevent="save">
        <b-form-group
                label="Id" label-for="id-input"
                invalid-feedback="Id is required"
                class="d-none">
          <b-form-input id="id-input"
                        v-model="$v.editedItem.id.$model"
                        :state="$v.editedItem.id.$dirty ? !$v.editedItem.id.$error : null"
                        :disabled="editedIndex  !== -1"
                        :readonly="editedIndex  !== -1"
                        :aria-disabled="editedIndex  !== -1"
                        :aria-readonly="editedIndex  !== -1"
                        required>
          </b-form-input>
        </b-form-group>

        <b-form-group
                label="Payroll Specialist" label-for="payroll-specialist-select"
                invalid-feedback="Payroll Specialist is required">
          <b-form-select id="payroll-specialist-select"
                         v-model="$v.editedItem.userAssignment.$model"
                         :state="$v.editedItem.userAssignment.$dirty ? !$v.editedItem.userAssignment.$error : null"
                         aria-describedby="select-2-live-feedback"
                         :options="payrollSpecialists"
                         value-field="userId"
                         text-field="name"
                         required>
          </b-form-select>
          <b-form-invalid-feedback id="select-2-live-feedback">
            This is a required field.
          </b-form-invalid-feedback>
          <b-form-text id="payroll-specialist-select-help">Required.</b-form-text>
        </b-form-group>

        <b-button @click="close" style="margin-right:15px;">Cancel</b-button>
        <b-button type="submit" variant="primary" :disabled="$v.editedItem.$invalid">Save</b-button>
      </form>
    </b-modal>

    <b-table hover small responsive show-empty
             :fields="fields"
             :items="assignedRequests"
             :busy="isLoading">
      <template #table-caption></template>
      <template v-slot:cell(actions)="row">
        <b-button size="sm" @click="editItem(row.item)" class="mr-1">
          edit
        </b-button>
      </template>

      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>

      <template v-slot:empty="scope">
        <p>No assignedRequests found.</p>
      </template>

      <div slot="table-busy" class="text-center text-danger my-2">
        <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
        <strong>Loading, Please Wait...</strong>
      </div>

    </b-table>
  </div>
</template>

<script>
  import axios from 'axios';
  import axiosRetry from 'axios-retry';
  import { validationMixin } from 'vuelidate'
  import { required, minLength } from 'vuelidate/lib/validators'
  import pageTitle from '@/mixins/pageTitle'

  axiosRetry(axios, { retries: 3,
    retryDelay: axiosRetry.exponentialDelay  });

  export default {
    title: 'Manage Payroll Assignments',
    mixins: [validationMixin, pageTitle],
    data: () => ({
      fields: [
        {key: 'mdhTrackingId', sortable: true, label: 'Number'},
        {key: 'division', sortable: true, label: 'Division'},
        {key: 'requestStatus', sortable: true, label: 'Lifecycle Status'},
        {key: 'statusLastDateTime', sortable: true, label: 'Status Date'},
        {key: 'lastUpdatedDateTime', sortable: true, label: 'Last Updated Date'},
        {key: 'employeeName', sortable: true, label: 'Employee Name'},
        {key: 'effectiveStartDate', sortable: true, label: 'Effective Start Date'},
        {key: 'supervisorName', sortable: true, label: 'Supervisor'},
        {key: 'assignedName', sortable: true, label: 'Assigned To'},
        {key: 'actions', label: 'Actions'}
      ],
      isLoading: false,
      assignedRequests: [],
      payrollSpecialists: [],
      editedIndex: -1,
      editedItem: {
        id: null,
        userAssignment: null,
      },
      defaultItem: {
        id: null,
        userAssignment: null,
      },
    }),

    validations: {
      editedItem: {
        id: {
          required
        },
        userAssignment: {
          required
        },
      }
    },

    watch: {
      assignedRequests() {
        this.isLoading = false;
      }
    },

    created () {
      this.initialize();
    },

    methods: {
      fetchAssignedRequests() {
        this.isLoading = true;
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/payroll/workinprogress`)
                .then(response => {
                  this.assignedRequests = response.data;
                  this.isLoading = false;
                });
      },

      fetchSpecialists() {
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/organization/payrollspecialist`)
                .then(response => {
                  this.payrollSpecialists = response.data;
                });
      },

      initialize () {
        this.fetchAssignedRequests();
        this.fetchSpecialists();
      },

      editItem (item) {
        this.editedIndex = this.assignedRequests.indexOf(item);
        this.editedItem = Object.assign({}, {id:item.id, userAssignment:item.assignedUserid});
        this.$bvModal.show('modal-crud');
      },

      close () {
        this.$bvModal.hide('modal-crud');
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
          this.fetchAssignedRequests();
        }, 300)
      },

      save () {
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/payroll/assignment`, this.editedItem)
          .then(response => {
            this.fetchAssignedRequests();
            this.$bvToast.toast('Assignment Updated', {
              title: 'Status',
              toaster: 'b-toaster-top-center',
              solid: true,
              variant: 'success',
              appendToast: true
            });
          });
        this.close();
      },
    }
  }
</script>